import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_TEXTBOX } from "@progress/kendo-angular-inputs";
import { EPC_READINGS, EnginePowerCheckGroup } from "./engine-power-check-group";
import { ChangedFieldDirective } from "../../changed-field.directive";

@Component({
    selector: "app-engine-power-check-tab",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_TEXTBOX],
    templateUrl: "./engine-power-check-tab.component.html",
    styleUrl: "../../edit-fields.scss",
})
export class EnginePowerCheckTabComponent {
    readonly group = input.required<EnginePowerCheckGroup>();
    readonly engines = input.required<(1 | 2)[]>();

    readonly readings = EPC_READINGS;
}
